export default {
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  left: {
    flex: '1 1 320px',
    maxWidth: '100%',
  },
  right: {
    flex: '2 1 640px',
    maxWidth: '100%',
  },
  z: {
    nav: 10000,
    dots: 1000, // in App.css
    a: 100,
  }
};



// WEBPACK FOOTER //
// ./src/assets/guides.js